import React from 'react';
import { Icon } from '@amzn/orion-components';
import { useNavigate } from 'react-router-dom';
import FinergyFloatingMenu from '../layout/FinergyFloatingMenu';
import { recordUserFeedback } from 'src/provider/RumProvider';
import type { FeedbackType } from 'src/common/types/feedback';
import { useFlashbar } from 'src/common/hooks/useFlashbar';

export interface TopNavProps {
  userAlias?: string;
  aboutLink?: string;
  issueLink?: string;
  onAskAI?: () => void;
}

const FEEDBACK_MESSAGE: Record<FeedbackType, string> = {
  LIKE: "Thank you for your positive feedback! We're glad you found this helpful.",
  DISLIKE:
    'Thank you for your feedback. A COMPASS POC will contact you soon to understand the concern and explore a resolution.',
};

export default function TopNav(props: TopNavProps) {
  const navigate = useNavigate();
  const { addMessage } = useFlashbar();

  const handleFeedback = (feedbackType: FeedbackType) => () => {
    recordUserFeedback({
      feedbackType,
      timestamp: new Date().toISOString(),
      userAlias: props.userAlias ?? '',
      page: window.location.pathname,
    });
    addMessage(FEEDBACK_MESSAGE[feedbackType], 'success');
  };

  return (
    <>
      <FinergyFloatingMenu />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px 24px 8px 56px',
          background: '#232f3e',
          borderBottom: '0',
          height: '56px',
          boxSizing: 'border-box',
        }}
      >
        {/* Left — branding */}
        <div
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: '12px' }}
          onClick={() => navigate('/')}
        >
          <div>
            <span
              style={{
                fontSize: '20px',
                fontWeight: 700,
                color: '#ffffff',
                display: 'block',
              }}
            >
              Controllership Hub
            </span>
            <span
              style={{ fontSize: '11px', color: '#e0f7fa', display: 'block', marginTop: '1px' }}
            >
              Streamlining controllership into a unified ecosystem
            </span>
          </div>
        </div>

        {/* Right — utility actions */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {props.onAskAI && (
            <button onClick={props.onAskAI} style={btnStyle}>
              <Icon name="sparkle" size={18} /> Ask AI
            </button>
          )}
          <button onClick={() => window.open(props.issueLink, '_blank')} style={btnStyle}>
            <Icon name="mail" size={18} />
          </button>
          <button onClick={() => window.open(props.aboutLink, '_blank')} style={btnStyle}>
            <Icon name="help" size={18} />
          </button>
          <button
            onClick={() =>
              window.open(`https://phonetool.amazon.com/users/${props.userAlias}`, '_blank')
            }
            style={btnStyle}
          >
            <Icon name="users" size={18} /> {props.userAlias}
          </button>
          <button onClick={handleFeedback('LIKE')} style={btnStyle} aria-label="Like CHub">
            <Icon name="thumbsUp" size={18} /> Like
          </button>
          <button onClick={handleFeedback('DISLIKE')} style={btnStyle} aria-label="Dislike CHub">
            <Icon name="thumbsDown" size={18} /> Dislike
          </button>
        </div>
      </div>
    </>
  );
}

const btnStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '4px 8px',
  background: 'transparent',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: 500,
  color: '#ffffff',
  transition: 'background 0.15s',
};
